<template>
  <v-dialog v-model="value" width="600" persistent>
    <v-card color="deep-purple lighten-5">
      <v-card-title>
        <span class="idcs-word-break">{{$t('title.print')}}</span>
        <v-spacer></v-spacer>
        <v-btn color="error" icon @click="$emit('input', false)">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="totalItems<ERROR_LENGTH">
        <v-alert
          v-if="totalItems>WARN_LENGTH && totalItems<ERROR_LENGTH"
          type="warning"
        >{{$t('alert.print_long')}}</v-alert>
        <v-alert v-if="totalItems>ERROR_LENGTH" type="error">{{$t('alert.print_disable')}}</v-alert>
        <v-layout row wrap align-content-space-around>
          <v-flex xs12>
            <v-switch
              v-model="print_all_det"
              :label="print_all_det?$t('label.excludeAll'):$t('label.includeAll')"
              @change="sel_all_det"
            ></v-switch>
          </v-flex>
          <v-flex xs12 sm6 lg4 v-for="d in details" :key="d.text">
            <v-checkbox v-model="d.prn" :label="d.text"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="totalItems<ERROR_LENGTH"
          text
          @click="$emit('click:ok'),$emit('input', false)"
          class="mr-4"
          color="blue darken-1"
        >{{$t('button.ok')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import app from "@/app.js";
export default {
  props: {
    value: { type: Boolean },
    allin: {
      type: Boolean,
      default() {
        return false;
      }
    },
    items: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      print_all_det: this.allin
    };
  },
  watch: {
    allin: {
      handler(nv) {
        this.print_all_det = nv;
      }
    }
  },
  computed: {
    WARN_LENGTH() {
      return app.WARN_LENGTH;
    },
    ERROR_LENGTH() {
      return app.ERROR_LENGTH;
    },
    totalItems() {
      return this.items.length;
    },
    details() {
      return this.items;
    }
  },
  methods: {
    sel_all_det() {
      let prn = this.print_all_det;
      this.items.forEach(e => {
        e.prn = prn;
      });
    }
  }
};
</script>

<style>
</style>